import React from 'react';
import {useDispatch} from 'react-redux';
import {
  SELECTED_PAY_TAXER_WITHHOLDING
} from '../../../redux/modules/shoppingCart/shoppingCart.module';
import styles from './TaxPayerModal.module.scss';

const TaxPayerModal = ({ onClose, history }) => {
  const dispatch = useDispatch();
  return (
    <div className={styles['loading-screen']}>
      <div className={styles['taxpayer-header']}>
        Has the IRS told you that you are subject to backup withholding?
      </div>
      <p className={styles['desc']}>
        If you are subject to backup withholding, T. Rowe Price will withold tax
        on all distributions, capital gains and dividends for the account
      </p>
      <div className={styles['button-container']}>
        <button
          className={styles['primary-withholding-button']}
          onClick={(e) => {
            dispatch({ type: SELECTED_PAY_TAXER_WITHHOLDING, payload: false });
            onClose();
          }}
        >
          No, I am not subject to withholding
        </button>
        <button
          onClick={(e) => {
            dispatch({ type: SELECTED_PAY_TAXER_WITHHOLDING, payload: true });
            onClose();
          }}
          className={styles['primary-withholding-button']}
        >
          Yes, I am subject to withholding
        </button>
      </div>
    </div>
  );
};

export default TaxPayerModal;
